import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-12bfc2a0")
const _hoisted_1 = { class: "lg:container lg:mx-auto pt-8" }
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-y-8 gap-x-0 lg:gap-x-8" }
const _hoisted_3 = { class: "col-span-2" }
const _hoisted_4 = {
  key: 1,
  class: "px-4 lg:px-0 flex flex-col"
}
const _hoisted_5 = { class: "flex flex-wrap items-center -mt-2" }
const _hoisted_6 = { class: "pool-title" }
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = {
  key: 0,
  class: "font-medium text-gray-400 text-xs mt-px ml-1"
}
const _hoisted_9 = { class: "flex items-center mt-2" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block" }, null, -1)
const _hoisted_12 = { class: "col-span-2 order-2 lg:order-1" }
const _hoisted_13 = { class: "grid grid-cols-1 gap-y-8" }
const _hoisted_14 = { class: "px-1 lg:px-0" }
const _hoisted_15 = { class: "mb-4 px-1 lg:px-0" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = ["textContent"]
const _hoisted_18 = ["textContent"]
const _hoisted_19 = {
  key: 0,
  class: "order-1 lg:order-2 px-1 lg:px-0"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_BalChip = _resolveComponent("BalChip")!
  const _component_LiquidityAPRTooltip = _resolveComponent("LiquidityAPRTooltip")!
  const _component_GauntletIcon = _resolveComponent("GauntletIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalTooltip = _resolveComponent("BalTooltip")!
  const _component_BalAlert = _resolveComponent("BalAlert")!
  const _component_PoolChart = _resolveComponent("PoolChart")!
  const _component_PoolStatCards = _resolveComponent("PoolStatCards")!
  const _component_PoolBalancesCard = _resolveComponent("PoolBalancesCard")!
  const _component_PoolTransactionsCard = _resolveComponent("PoolTransactionsCard")!
  const _component_MyPoolBalancesCard = _resolveComponent("MyPoolBalancesCard")!
  const _component_PoolActionsCard = _resolveComponent("PoolActionsCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loadingPool)
          ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
              key: 0,
              class: "h-16"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.poolTypeLabel), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleTokens, ([address, tokenMeta], i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "mt-2 mr-2 flex items-center px-2 h-10 bg-gray-50 dark:bg-gray-850 rounded-lg"
                  }, [
                    _createVNode(_component_BalAsset, { address: address }, null, 8, ["address"]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(tokenMeta.symbol), 1),
                    (!_ctx.isStableLikePool)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.fNum2(tokenMeta.weight, {
                    style: 'percent',
                    maximumFractionDigits: 0
                  })), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (_ctx.pool.dynamic.isNewPool)
                  ? (_openBlock(), _createBlock(_component_BalChip, {
                      key: 0,
                      color: "red",
                      size: "sm",
                      class: "uppercase mt-2 mr-2",
                      outline: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('new')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_LiquidityAPRTooltip, {
                  pool: _ctx.pool,
                  class: "-ml-1 mt-1"
                }, null, 8, ["pool"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  innerHTML: _ctx.poolFeeLabel,
                  class: "text-sm text-gray-600"
                }, null, 8, _hoisted_10),
                _createVNode(_component_BalTooltip, null, {
                  activator: _withCtx(() => [
                    (_ctx.feesManagedByGauntlet)
                      ? (_openBlock(), _createBlock(_component_BalLink, {
                          key: 0,
                          href: _ctx.EXTERNAL_LINKS.Gauntlet.Home,
                          external: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_GauntletIcon, { class: "ml-2" })
                          ]),
                          _: 1
                        }, 8, ["href"]))
                      : (_openBlock(), _createBlock(_component_BalIcon, {
                          key: 1,
                          name: "info",
                          size: "xs",
                          class: "text-gray-400 ml-2"
                        }))
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.swapFeeToolTip), 1)
                  ]),
                  _: 1
                })
              ])
            ])),
        (!_ctx.appLoading && _ctx.missingPrices)
          ? (_openBlock(), _createBlock(_component_BalAlert, {
              key: 2,
              type: "warning",
              title: _ctx.$t('noPriceInfo'),
              class: "mt-2",
              block: ""
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        (!_ctx.appLoading && _ctx.hasCustomToken)
          ? (_openBlock(), _createBlock(_component_BalAlert, {
              key: 3,
              type: "error",
              title: _ctx.$t('highRiskPool'),
              class: "mt-2",
              block: ""
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        (!_ctx.appLoading && _ctx.noInitLiquidity)
          ? (_openBlock(), _createBlock(_component_BalAlert, {
              key: 4,
              type: "warning",
              title: _ctx.$t('noInitLiquidity'),
              description: _ctx.$t('noInitLiquidityDetail'),
              class: "mt-2",
              block: ""
            }, null, 8, ["title", "description"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_PoolChart, {
              pool: _ctx.pool,
              historicalPrices: _ctx.historicalPrices,
              snapshots: _ctx.snapshots,
              loading: _ctx.isLoadingSnapshots
            }, null, 8, ["pool", "historicalPrices", "snapshots", "loading"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_PoolStatCards, {
              pool: _ctx.pool,
              loading: _ctx.loadingPool
            }, null, 8, ["pool", "loading"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h4", {
              textContent: _toDisplayString(_ctx.$t('poolComposition')),
              class: "px-4 lg:px-0 mb-4"
            }, null, 8, _hoisted_17),
            _createVNode(_component_PoolBalancesCard, {
              pool: _ctx.pool,
              loading: _ctx.loadingPool
            }, null, 8, ["pool", "loading"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("h4", {
              textContent: _toDisplayString(_ctx.$t('poolTransactions.title')),
              class: "px-4 lg:px-0 mb-2"
            }, null, 8, _hoisted_18),
            _createVNode(_component_PoolTransactionsCard, {
              pool: _ctx.pool,
              loading: _ctx.loadingPool
            }, null, 8, ["pool", "loading"])
          ])
        ])
      ]),
      (!_ctx.isLiquidityBootstrappingPool)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_ctx.loadingPool)
              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                  key: 0,
                  class: "pool-actions-card h-60 mb-4"
                }))
              : (!_ctx.noInitLiquidity)
                ? (_openBlock(), _createBlock(_component_MyPoolBalancesCard, {
                    key: 1,
                    pool: _ctx.pool,
                    missingPrices: _ctx.missingPrices,
                    class: "mb-4"
                  }, null, 8, ["pool", "missingPrices"]))
                : _createCommentVNode("", true),
            (_ctx.loadingPool)
              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                  key: 2,
                  class: "pool-actions-card h-40"
                }))
              : (!_ctx.noInitLiquidity)
                ? (_openBlock(), _createBlock(_component_PoolActionsCard, {
                    key: 3,
                    pool: _ctx.pool,
                    missingPrices: _ctx.missingPrices
                  }, null, 8, ["pool", "missingPrices"]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}